import { create } from 'zustand';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../utils/firebase.js';

export const useAuthStore = create((set) => ({
    user: null,
    isAuthenticated: false,
    isAuthLoading: true,
    error: null,
    lastLoginWritePerformed: false,
    mustAgreeToTerms: false,

    setUser: (firebaseUser) => {
        set({
            user: firebaseUser,
            displayName: firebaseUser?.auth?.currentUser?.displayName,
            isAuthenticated: !!firebaseUser,
            isAuthLoading: false,
            error: null
        });
    },

    setDisplayName: (newName) => set({ displayName: newName }),

    setLoading: (loadingStatus) => {
        set({ isAuthLoading: loadingStatus });
    },

    setError: (errorMessage) => {
        set({ error: errorMessage, isAuthLoading: false });
    },

    setLastLoginWritePerformed: (status) => {
        set({ lastLoginWritePerformed: status });
    },

    setMustAgreeToTerms: (hasAgreedToCurrentTerms) => {
        set({ mustAgreeToTerms: hasAgreedToCurrentTerms })
    },

    logout: () => {
        set({
            user: null,
            isAuthenticated: false,
            error: null,
            lastLoginWritePerformed: false,
        });
    }
}));